import { Link } from '@inertiajs/react';

const BadgeVariants = {
    default: 'bg-gray-200 border-gray-300 text-gray-700',
    success: 'bg-green-200 border-green-300 text-green-900',
    secondary: 'bg-white border-gray-200 text-gray-700',
    list: 'bg-orange-100 border-orange-200 text-orange-800',
} as const;

type BadgeProps = {
    variant?: keyof typeof BadgeVariants;
    href?: string;
    children: React.ReactNode;
};

export function Badge({ variant = 'default', href = '', children }: BadgeProps) {
    const BadgeComponent = href ? Link : 'span';

    return (
        <BadgeComponent
            href={href}
            className={
                BadgeVariants[variant] + ' inline-flex min-h-6 items-center rounded-md border px-2 text-sm font-medium'
            }
        >
            {children}
        </BadgeComponent>
    );
}
